import { Reveal } from '../components/Reveal'
import { Kicker } from '../components/Kicker'
import { FluidHeading } from '../components/FluidHeading'

const STEPS = [
  { step: '01', title: 'Imersão', desc: 'Entendemos seu negócio, público, concorrência, momento e objetivos.' },
  { step: '02', title: 'Estratégia', desc: 'Definimos canais, comunicação, oferta, criativos e estrutura necessária para a campanha.' },
  { step: '03', title: 'Execução', desc: 'Colocamos a estratégia em movimento: campanhas, criativos, páginas e demais pontos necessários.' },
  { step: '04', title: 'Análise & Otimização', desc: 'Acompanhamos os dados, identificamos oportunidades e evoluímos continuamente.' },
]

export function Process() {
  return (
    <section id="processo" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <Kicker>Como trabalhamos</Kicker>
          <FluidHeading as="h2" className="text-3xl font-semibold text-white sm:text-5xl">
            Nosso <span className="text-gradient">processo orbital</span>
          </FluidHeading>
          <p className="mt-4 text-white/55">
            Um método claro, do primeiro contato ao crescimento contínuo.
          </p>
        </div>
      </Reveal>

      <div className="relative mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="pointer-events-none absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-transparent via-orb-500/40 to-transparent lg:block" />
        <div className="pointer-events-none absolute bottom-6 left-6 top-6 w-px bg-gradient-to-b from-orb-500/40 via-orb-500/25 to-transparent sm:hidden" />
        {STEPS.map((step, i) => (
          <Reveal key={step.step} delay={i * 0.22}>
            <div className="relative">
              <div className="glow-border relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-space-900 font-display text-sm font-semibold text-orb-200">
                {step.step}
              </div>
              <FluidHeading as="h3" className="mt-5 text-lg font-semibold text-white">
                {step.title}
              </FluidHeading>
              <p className="mt-2.5 text-sm leading-relaxed text-white/60">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
